import { type ContainerFrequencyOptions } from '@hungryroot/rest';
import { segmentAnalytics } from '@hungryroot/segment';
import { type Quiz } from '../defs/quiz';

export type QuizPreferenceItem = {
  name: string;
  id: number;
  type: 'pairing' | 'product' | 'tag';
};

export type QuizProteinPreferenceItem = {
  name: string;
  id: number;
  preference: -1 | 0 | 1;
};

function getArrayData(items: string[] | number[]) {
  return items.length > 0 ? items : null;
}

export function eatingHabitsAnalytics(diet: Quiz['habits']) {
  segmentAnalytics.track('Quiz Diet', {
    diet: diet,
  });
}

export function tagAnalytics(eventName: string, items: QuizPreferenceItem[]) {
  segmentAnalytics.track(eventName, {
    tag_id: getArrayData(items.map((item) => item.id)),
    tag_name: getArrayData(items.map((item) => item.name)),
  });
}

export function foodPreferenceAnalytics(
  containerName: string,
  items: QuizPreferenceItem[]
) {
  segmentAnalytics.track('Quiz Food Preferences', {
    container_name: containerName,
    item_name: getArrayData(items.map((item) => item.name)),
    pairing_id: getArrayData(
      items.filter((item) => item.type === 'pairing').map((item) => item.id)
    ),
    product_id: getArrayData(
      items.filter((item) => item.type === 'product').map((item) => item.id)
    ),
    tag_id: getArrayData(
      items.filter((item) => item.type === 'tag').map((item) => item.id)
    ),
  });
}

export function containerFrequencyAnalytics(
  containerName: string,
  frequency: ContainerFrequencyOptions | null
) {
  segmentAnalytics.track('Quiz Container Frequencies', {
    container_name: containerName,
    frequency: frequency,
  });
}

export function proteinPreferenceAnalytics({
  id,
  name,
  preference,
}: QuizProteinPreferenceItem) {
  segmentAnalytics.track('Quiz Protein Preferences', {
    tag_id: id,
    tag_name: name,
    preference: preference,
  });
}
